<div class="report-settings" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar top" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" [attr.data-automation-id]="automationId + '-save-button'" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="!hasReportsViewOnlyPermission">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDisabled()"
            *ngIf="!hasReportsViewOnlyPermission">Discard
            Changes</button>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()"><i class="fa fa-question"></i></button>
    </div>

    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex" [(isBusy)]="isBusy"
        [(isBusyMessage)]="isBusyMessage" [columnDefs]="columnDefs" [requestInfo]="requestInfo" [pagerVisible]="false"
        [cellClickedCallback]="cellClickedCallback" [rowClassRules]="rowClassRules">
    </res-generic-grid>
</div>